import { action, makeAutoObservable, reaction, runInAction } from "mobx";
import { Availability } from "../Availability";
export class DeliveryAddress {
    constructor(params) {
        this._dispose = null;
        this.restaurantId = params.restaurantId;
        this.geocodingService = params.geocodingService;
        this.streetAddress = params.streetAddress;
        this.apartmentInfo = params.apartmentInfo;
        this._status = { type: "NotRequested" };
        makeAutoObservable(this);
    }
    get isEmpty() {
        return this.streetAddress.isEmpty && this.apartmentInfo.isEmpty;
    }
    /**
     * Watch for changes in streetAddress and update status accordingly
     */
    initialize() {
        if (this._dispose) {
            throw new Error("DeliveryAddress already initialized");
        }
        this._dispose = reaction(() => this.streetAddress.checkoutData, () => {
            runInAction(() => {
                this._status = { type: "Loading" };
            });
            this.geocodingService
                .getDeliveryAddressStatus(this.restaurantId, this.streetAddress)
                .then(action((status) => (this._status = status)))
                .catch(action((error) => {
                this._status = { type: "NetworkError" };
                console.log("Getting address info failed", error);
            }));
        }, { delay: 1000, fireImmediately: true });
    }
    dispose() {
        if (this._dispose) {
            this._dispose();
        }
    }
    get status() {
        return this._status;
    }
    get coordinates() {
        return "coordinates" in this._status ? this._status.coordinates : null;
    }
    get availability() {
        return Availability.composite([
            this.streetAddress.availability,
            this.apartmentInfo.availability,
            this.status.type === "RestaurantDelivers"
                ? Availability.available()
                : Availability.unavailable("RestaurantDoesntDeliver"),
        ]);
    }
    get checkoutData() {
        return {
            ...this.streetAddress.checkoutData,
            apartmentNumber: this.apartmentInfo.checkoutData.aptNumber,
            floor: this.apartmentInfo.checkoutData.floor,
            country: this.streetAddress.country,
            extra: this.apartmentInfo.checkoutData,
            formattedAddress: null,
            coordinates: this.coordinates,
        };
    }
}
